import { arrow, computePosition, flip, offset, shift } from '@floating-ui/dom';

import { tooltipShortcut } from './tooltip-shortcut';

export function initTooltip(el, binding) {
    const tooltip = document.createElement('div');
    const tooltipArrow = document.createElement('div');

    tooltip.role = 'tooltip';
    tooltip.classList.add('tooltip-floating');

    if (binding.content) {
        tooltip.textContent = binding.content;
    }

    if (binding.shortcut) {
        tooltip.innerHTML = tooltipShortcut(
            binding.content ?? '',
            binding.shortcut
        );
    }

    tooltipArrow.classList.add('tooltip-floating-arrow');
    tooltip.insertBefore(tooltipArrow, null);
    el.parentNode?.insertBefore(tooltip, el.nextElementSibling);

    void computePosition(el, tooltip, {
        placement: 'top',
        strategy: 'fixed',
        middleware: [
            flip(),
            offset(6),
            shift({ padding: 5 }),
            arrow({ element: tooltipArrow, padding: 5 }),
        ],
    }).then(({ x, y, placement, middlewareData }) => {
        Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
        });

        const { x: arrowX, y: arrowY } = middlewareData.arrow;

        const staticSide = {
            top: 'bottom',
            right: 'left',
            bottom: 'top',
            left: 'right',
        }[placement.split('-')[0]];

        Object.assign(tooltipArrow.style, {
            left: arrowX != null ? `${arrowX}px` : '',
            top: arrowY != null ? `${arrowY}px` : '',
            right: '',
            bottom: '',
            [staticSide]: '-4px',
        });
    });

    function showTooltip() {
        tooltip.style.opacity = '1';
    }

    function hideTooltip() {
        tooltip.style.opacity = '0';
    }

    [
        ['mouseenter', showTooltip],
        ['mouseleave', hideTooltip],
        ['focus', showTooltip],
        ['blur', hideTooltip],
    ].forEach(([event, listener]) => {
        el.addEventListener(event, listener);
    });

    el.setAttribute('data-tooltip-init', '');
}
